import type { CSSProperties } from 'react';
import { UMR } from './referenceTokens';

interface UMIconProps {
  /** Ligature name, e.g. "layers", "shape_line". */
  name: string;
  size?: number;
  color?: string;
  weight?: number;
  /**
   * Production mixes two Google icon fonts: Material Symbols Outlined (rail, toolbar, panels)
   * and Material Icons (zoom buttons, input chevrons, legend "visibility", tag arrows).
   */
  family?: 'symbols' | 'icons';
  /** Square box size around the glyph (defaults to the glyph size). */
  box?: number;
  style?: CSSProperties;
}

/** Icon glyph rendered exactly like the production UrbanMap app. */
export function UMIcon({ name, size = 24, color, weight, family = 'symbols', box, style }: UMIconProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        fontFamily: family === 'icons' ? '"Material Icons"' : UMR.iconFont,
        fontSize: size,
        lineHeight: 1,
        width: box ?? size,
        height: box ?? size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontWeight: weight ?? 400,
        color,
        userSelect: 'none',
        fontFeatureSettings: '"liga"',
        overflow: 'hidden',
        ...style,
      }}
    >
      {name}
    </span>
  );
}
